import type { AssistantUITheme } from '@adsk/adp-web-analytics-sdk/lib/AssistantUI';
import type { INFO360_THEMES } from '@innovyze/stylovyze';

export function info360ToAssistantTheme(
  info360Theme: INFO360_THEMES,
): AssistantUITheme {
  switch (info360Theme) {
    case 'HIG Light Theme':
      return { color: 'light-gray', density: 'medium' };
    case 'HIG Light Theme (High Density)':
      return { color: 'light-gray', density: 'high' };
    case 'HIG Dark Theme':
      return { color: 'dark-blue', density: 'medium' };
    case 'HIG Dark Theme (High Density)':
      return { color: 'dark-blue', density: 'high' };
    case 'innovyze':
      return { color: 'light-gray', density: 'medium' };
    default:
      return { color: 'light-gray', density: 'medium' };
  }
}
